import { CommonModule, DatePipe, DecimalPipe, NgOptimizedImage, registerLocaleData } from '@angular/common';
import { LOCALE_ID, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import {
  AmountInputComponent,
  BalanceOverdraftDialogComponent,
  BusinessHistoryDialogComponent,
  ButtonLayoutAusfuehrenComponent,
  CreditLimitOverrunDialogComponent,
  CustomerIncludeComponent,
  DateInputComponent,
  ErrorPageComponent,
  FooterComponent,
  HeaderComponent,
  HelpTextComponent,
  LayoutComponent,
  LogoutPageComponent,
  NavbarComponent,
  PageTitleComponent,
  PrintButtonComponent,
  SpinnerOverlayComponent,
  TaskLogComponent,
  TradeEventDialogComponent,
  UserComponent
} from '@shared/ui-common';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { TableModule } from 'primeng/table';
import { DialogModule } from 'primeng/dialog';
import { PanelModule } from 'primeng/panel';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { NumberFromStringDEPipe, StringDEFromNumberPipe } from '@shared/util-locale';
import { InputNumberModule } from 'primeng/inputnumber';
import { CheckboxModule } from 'primeng/checkbox';
import localeDe from '@angular/common/locales/de';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { ListboxModule } from 'primeng/listbox';
import { SelectModule } from 'primeng/select';
import {
  FormBestandComponent,
  FormBetragComponent,
  FormCommentComponent,
  FormValutaComponent,
  FormVerfuegbarkeitComponent,
  FormZinsComponent
} from '@shared/ui-form-parts';
import { TooltipModule } from 'primeng/tooltip';
import { RouterModule } from '@angular/router';
import { DatePickerModule } from 'primeng/datepicker';
import { TextareaModule } from 'primeng/textarea';
import { AmountInputDirective, DateInputDirective } from './data/index';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageModule } from 'primeng/message';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { LeadingZeroDirective } from '@shared/ui-form-control';

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    LayoutComponent,
    NavbarComponent,
    UserComponent,
    DateInputComponent,
    AmountInputComponent,
    StringDEFromNumberPipe,
    NumberFromStringDEPipe,
    TaskLogComponent,
    SpinnerOverlayComponent,
    HelpTextComponent,
    ErrorPageComponent,
    LogoutPageComponent,
    CustomerIncludeComponent,
    PageTitleComponent,
    ButtonLayoutAusfuehrenComponent,
    AmountInputDirective,
    FormBetragComponent,
    FormBestandComponent,
    FormZinsComponent,
    FormValutaComponent,
    FormCommentComponent,
    FormVerfuegbarkeitComponent,
    PrintButtonComponent,
    DateInputDirective,
    TradeEventDialogComponent,
    BusinessHistoryDialogComponent,
    LeadingZeroDirective,
    CreditLimitOverrunDialogComponent,
    BalanceOverdraftDialogComponent
  ],
  imports: [
    CommonModule,
    TranslateModule,
    MenubarModule,
    MenuModule,
    ButtonModule,
    CardModule,
    AvatarModule,
    ToggleSwitchModule,
    ProgressSpinnerModule,
    ToastModule,
    ReactiveFormsModule,
    InputGroupModule,
    InputGroupAddonModule,
    InputTextModule,
    TableModule,
    SelectModule,
    DialogModule,
    PanelModule,
    AutoCompleteModule,
    InputTextModule,
    DividerModule,
    FormsModule,
    InputNumberModule,
    CheckboxModule,
    ListboxModule,
    TooltipModule,
    RouterModule,
    DatePickerModule,
    NgOptimizedImage,
    TextareaModule,
    ConfirmDialogModule,
    MessageModule,
    IconFieldModule,
    InputIconModule
  ],
  providers: [
    MessageService,
    {
      provide: LOCALE_ID,
      useValue: 'de-DE'
    },
    StringDEFromNumberPipe,
    NumberFromStringDEPipe,
    DatePipe,
    ConfirmationService,
    DecimalPipe
  ],
  exports: [
    DateInputComponent,
    AmountInputComponent,
    StringDEFromNumberPipe,
    NumberFromStringDEPipe,
    FooterComponent,
    HeaderComponent,
    LayoutComponent,
    NavbarComponent,
    UserComponent,
    TaskLogComponent,
    SpinnerOverlayComponent,
    HelpTextComponent,
    ErrorPageComponent,
    LogoutPageComponent,
    CustomerIncludeComponent,
    PageTitleComponent,
    ButtonLayoutAusfuehrenComponent,
    FormBetragComponent,
    FormBestandComponent,
    FormZinsComponent,
    FormValutaComponent,
    FormCommentComponent,
    FormVerfuegbarkeitComponent,
    PrintButtonComponent,
    AmountInputDirective,
    DateInputDirective,
    TradeEventDialogComponent,
    LeadingZeroDirective,
    BusinessHistoryDialogComponent,
    CreditLimitOverrunDialogComponent,
    BalanceOverdraftDialogComponent
  ]
})
export class SharedModule {}
